import { Icon } from '@/components/ui/icon';
import { getButtonIcon } from '@/lib/blocks/button-links';
import type { ButtonConfig } from '@/types/button';

interface ButtonContentProps {
  text?: string;
  icon?: ButtonConfig['icon'];
  iconPlacement?: ButtonConfig['iconPlacement'];
}

export function ButtonContent({ text, icon, iconPlacement }: ButtonContentProps) {
  const iconDefinition = getButtonIcon(icon);
  const placement = iconPlacement || 'before';
  return (
    <>
      {iconDefinition && placement === 'before' ? (
        <Icon icon={iconDefinition} className="size-4" />
      ) : null}
      {text ?? ''}
      {iconDefinition && placement === 'after' ? (
        <Icon icon={iconDefinition} className="size-4" />
      ) : null}
    </>
  );
}
